import { initTeamList } from '../modules/Components/team-list.js';
import { initTimelineSlider } from '../modules/Components/timeline-slider.js';

function init() {
  initTeamList();
  initTimelineSlider();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
